// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-21627288] .ant-modal-footer {\n  text-align: center;\n}\n[data-v-21627288] .ant-form-item-required .anticon-question-circle {\n  height: 16px;\n  vertical-align: middle;\n}\n.circle-label[data-v-21627288] .ant-form-item-label {\n  display: block;\n  overflow: auto;\n  white-space: wrap;\n}", ""]);
// Exports
module.exports = exports;
